"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _Loading = _interopRequireDefault(require("./Loading"));

var _default = _Loading.default;
exports.default = _default;